import React, { useState } from 'react';
import { Typography, List, Tag, Popconfirm, Space, Card, Row, Col, Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';

const { Text } = Typography;

const EntryItem = ({ item, onEdit, onDelete }) => {
    const { t } = useTranslation();
    const [isHovered, setIsHovered] = useState(false);

    const cardStyle = {
        marginBottom: 8,
        boxShadow: isHovered ? '0 2px 8px rgba(0, 0, 0, 0.1)' : '0 1px 4px rgba(0, 0, 0, 0.05)',
        transition: 'all 0.3s',
        borderRadius: 4,
        width: '100%'
    };

    const contentBoxStyle = {
        padding: '0',
        borderRadius: 4,
    };

    const questionBoxStyle = {
        ...contentBoxStyle,
        backgroundColor: '#e6f7ff',
        border: '1px solid #91caff'
    };

    const answerBoxStyle = {
        ...contentBoxStyle,
        backgroundColor: '#f5f5f5',
        border: '1px solid #d9d9d9'
    };

    const actions = isHovered ? [
        <Space>
            <EditOutlined
                key="edit"
                style={{ fontSize: 16, color: '#1890ff' }}
                onClick={() => onEdit(item)}
            />
            <Popconfirm
                title={t('delete_this_entry')}
                onConfirm={() => onDelete(item.id)}
                okText={t('yes')}
                cancelText={t('no')}
            >
                <DeleteOutlined
                    key="delete"
                    style={{ fontSize: 16, color: '#ff4d4f' }}
                />
            </Popconfirm>
        </Space>
    ] : [];

    return (
        <List.Item style={{ padding: 0, width: '100%' }}>
            <Card
                style={cardStyle}
                styles={{ body: { padding: '12px' } }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
            >
                <Row>
                    <Col span={24}>
                        <Flex style={{ width: '100%' }} align='center' gap={8}>
                            <Space style={{ flexGrow: 1 }}>
                                <Tag color={item.entry_type === 'question_answer' ? 'blue' : 'green'}
                                    style={{ padding: '2px 8px', fontSize: 12, margin: 0 }}>
                                    {item.entry_type === 'question_answer' ? t('qa') : t('business_info')}
                                </Tag>
                            </Space>
                            {actions}
                            <Text type="secondary" style={{ fontSize: 12, padding: 0 }}>
                                {format(new Date(item.created_at), 'MMM d, yyyy')}
                            </Text>
                        </Flex>

                        {item.entry_type === 'question_answer' ? (
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Card style={questionBoxStyle} styles={{ body: { padding: '12px' } }} bordered={false}>
                                    <Text strong style={{ fontSize: 13, color: '#1890ff', }}>
                                        {t('q_prefix')} {item.data.question}
                                    </Text>
                                </Card>
                                <Card style={answerBoxStyle} styles={{ body: { padding: '12px' } }} bordered={false}>
                                    <Text style={{ fontSize: 13 }}>
                                        {t('a_prefix')} {item.data.answer}
                                    </Text>
                                </Card>
                            </Space>
                        ) : (
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Card styles={{ body: { padding: '12px' } }} style={answerBoxStyle} bordered={false}>
                                    <Text style={{ fontSize: 13, padding: 0 }}>
                                        {item.data.content}
                                    </Text>
                                </Card>
                            </Space>
                        )}
                    </Col>
                </Row>
            </Card>
        </List.Item >
    );
};

export default EntryItem;
